import { useContext } from 'react';
import { IStaticHostingSettingData } from '@Type';
import { StaticHostingContext } from '../stores/provider';

const useStaticHosting = (): IStaticHostingSettingData | null => {
  return useContext(StaticHostingContext);
};
export default useStaticHosting;
